(function() {
	'use strict';
	var $ = avm.require('cash'),

		$tablesTooltip = $('.tables__tooltip'),

		$selectInputUltimate__toggler = $('.js-actionbox__ultimate select'),
		$selectInputPremium__toggler = $('td.js-actionbox__premiumSecurity select'),

		$premiumSecurity__td = $('.js-premiumSecurity__td'),
		$premiumSecurity__td_yes = $('.js-premiumSecurity__td--yes'),
		$premiumSecurity__td_no = $('.js-premiumSecurity__td--no'),

		$ultimate__td = $('.js-ultimate__td'),
		$ultimate__td_yes = $('.js-ultimate__td--yes'),
		$ultimate__td_no = $('.js-ultimate__td--no');


	// Keyboard accessible Tooltips - show tooltip when focused
	$tablesTooltip.on('focus', function(e){
		$( this ).trigger('mouseenter');
	}).on('blur', function(e){
		$( this ).trigger('mouseleave');
	});


	/*
	* Change icon based on Toggler value
	* ----------------------------------
	* if “10 devices” selected ▶︎ set ✅ icon
	* else ▶︎ set ❌ icon
	*/

	// 👑 U L T I M A T E
	function toggleUltimate() {
		var itemLabel, is10DevicesActive;

		setTimeout(function(){
			itemLabel = $selectInputUltimate__toggler.find('option.active')[0].label;
			is10DevicesActive = itemLabel.indexOf('10') !== -1; // search for "10" devices - all locales have "10" in the string

			if( is10DevicesActive ) {
				$ultimate__td.addClass('bg-tinged');
				$ultimate__td_no.addClass('d-none');
				$ultimate__td_yes.removeClass('d-none');
			}
			else {
				$ultimate__td.removeClass('bg-tinged');
				$ultimate__td_yes.addClass('d-none');
				$ultimate__td_no.removeClass('d-none');
			}
		}, 100);
	}

	// ⭐️ P R E M I U M
	function togglePremiumSecurity() {
		var itemLabel, is10DevicesActive;

		setTimeout(function(){
			itemLabel = $selectInputPremium__toggler.find('option.active')[0].label;
			is10DevicesActive = itemLabel.indexOf('10') !== -1; // search for "10" devices - all locales have "10" in the string

			if( is10DevicesActive ) {
				$premiumSecurity__td.addClass('bg-tinged');
				$premiumSecurity__td_no.addClass('d-none');
				$premiumSecurity__td_yes.removeClass('d-none');
			}
			else {
				$premiumSecurity__td.removeClass('bg-tinged');
				$premiumSecurity__td_yes.addClass('d-none');
				$premiumSecurity__td_no.removeClass('d-none');
			}
		}, 100);
	}

	// onChange
	$selectInputUltimate__toggler.on('change', toggleUltimate);
	$selectInputPremium__toggler.on('change', togglePremiumSecurity);

	// onDocumentReady
	toggleUltimate();
	togglePremiumSecurity();

})();
